var map = {
	"./app.js": "ZERL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bUwL";


//////////////////
// WEBPACK FOOTER
// ./src/topdoor/store/modules nonrecursive \.js$
// module id = bUwL
// module chunks = 1